import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    border-radius: 0.3rem;
    width: 100%;

    height: 100%;

    & > * {
        padding: 2px;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }

    & > button {
        height: 100%;
    }
`

export const Input = styled.input.attrs({
    type: 'number'
})`
    box-shadow: 0px;
    outline: none;
    margin: 0;
    border: none;
    width: 40%;
    /* border-top: 2px solid ${ThemeColors.gray};
    border-bottom: 2px solid ${ThemeColors.gray}; */
    text-align: center;
    font-size: inherit;
    padding: 2px;
    appearance: none;
    -webkit-appearance: none;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`
export const ButtonLeft = styled.button`
    box-shadow: 0px;
    outline: none;
    margin: 0;
    width: 30%;
    background-color: ${ThemeColors.getGrayColor(0.1)};

    &:hover {
        background-color: ${ThemeColors.getGrayColor(0.08)};
    }

    border: none;
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const ButtonRight = styled.button`
    box-shadow: 0px;
    outline: none;
    margin: 0;
    width: 30%;
    border: none;
    background-color: ${ThemeColors.accentGreen};

    &:hover {
        background-color: ${ThemeColors.accentGreenLight};
    }

    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const IconImg = styled.img`
    width: 100%;
    height: auto;
`
